import i18next from 'i18next';
import FILTER_TYPES from '../Shared/Table/widgets/Filters/constants';
import {
  CUSTOM_TAGS_OPTIONS,
  PATIENT_CUSTOM_TAGS_OPTIONS,
  SURVEY_TAGS_OPTIONS,
} from '../Shared/CustomTags';
import permissions from '../../config/permissions';
import { INFO_PANE_PAGES } from '../../redux_store/reducer/reducers/infoPaneReducer';
import { ASSESSMENT_STATUSES_OPTIONS } from '../Assessments/constants';

export const BOT_UPLOADS_STATUSES = {
  success: 'success',
  error: 'error',
  pending: 'pending',
};

export const BOT_UPLOADS_STATUSES_OPTIONS = [
  {
    label: i18next.t('tables:success'),
    value: BOT_UPLOADS_STATUSES.success,
  },
  {
    label: i18next.t('tables:error'),
    value: BOT_UPLOADS_STATUSES.error,
  },
  {
    label: i18next.t('tables:pending'),
    value: BOT_UPLOADS_STATUSES.pending,
  },
];


export const GET_BOT_ACTIVITIES_COLUMNS = (isPatientPage) => [
  {
    size: 200,
    header: i18next.t('tables:customTags'),
    accessorKey: 'accountCustomTags',
    filter: {
      filterType: FILTER_TYPES.SELECT,
      options: CUSTOM_TAGS_OPTIONS,
    },
    cell: {
      withBubbles: true,
    },
    permission: permissions.ACCOUNTS_GET,
  },
  {
    size: 200,
    header: i18next.t('tables:surveyTags'),
    accessorKey: 'surveyTags',
    filter: {
      filterType: FILTER_TYPES.SELECT,
      options: SURVEY_TAGS_OPTIONS,
    },
    cell: {
      withBubbles: true,
    },
    permission: permissions.ACCOUNTS_GET,
  },
  {
    size: 220,
    header: i18next.t('tables:account'),
    accessorKey: 'accountBusinessName',
    filter: {
      filterType: FILTER_TYPES.SELECT_WITH_DYNAMIC_HINT,
    },
    permission: permissions.ACCOUNTS_GET,
    enableHiding: false,
    isDefaultCell: true,
  },
  {
    size: 260,
    header: i18next.t('tables:patientCustomTags'),
    accessorKey: 'patientCustomTags',
    filter: {
      filterType: FILTER_TYPES.SELECT,
      options: PATIENT_CUSTOM_TAGS_OPTIONS,
    },
    cell: {
      withBubbles: true,
    },
    permission: permissions.ACCOUNTS_GET,
  },
  {
    size: 180,
    header: i18next.t('tables:customId'),
    accessorKey: 'accountCustomIdentifier',
    filter: {},
    permission: permissions.ACCOUNTS_GET,
    enableHiding: false,
    isDefaultCell: true,
  },
  {
    size: 200,
    header: i18next.t('tables:mrnNumber'),
    accessorKey: 'patientMrnNumber',
    filter: {},
    cell: {
      infoPanePage: INFO_PANE_PAGES.patient_page,
    },
  },
  {
    size: 240,
    header: i18next.t('tables:patientFirstName'),
    accessorKey: 'patientFirstName',
    filter: {},
    hidden: isPatientPage,
    cell: {
      infoPanePage: INFO_PANE_PAGES.patient_page,
    },
  },
  {
    size: 240,
    header: i18next.t('tables:patientLastName'),
    accessorKey: 'patientLastName',
    filter: {},
    hidden: isPatientPage,
    cell: {
      infoPanePage: INFO_PANE_PAGES.patient_page,
    },
  },
  {
    size: 200,
    header: i18next.t('tables:patientDOB'),
    accessorKey: 'patientDateOfBirth',
    hidden: isPatientPage,
    filter: { filterType: FILTER_TYPES.DATE },
    isDefaultCell: true,
  },
  {
    size: 230,
    header: i18next.t('tables:assessmentName'),
    accessorKey: 'surveyName',
    filter: {
      filterType: FILTER_TYPES.SELECT_WITH_DYNAMIC_HINT,
    },
    isDefaultCell: true,
  },
  {
    size: 200,
    header: i18next.t('tables:orderDate'),
    accessorKey: 'orderDate',
    filter: {
      shouldRange: true,
      filterType: FILTER_TYPES.DATE,
    },
    isDefaultCell: true,
  },
  {
    size: 250,
    header: i18next.t('tables:appointmentTimestamp'),
    accessorKey: 'appointmentTimestamp',
    filter: {
      shouldRange: true,
      hasNoMaxDate: true,
      filterType: FILTER_TYPES.DATE,
    },
    isDefaultCell: true,
  },
  {
    size: 200,
    header: i18next.t('tables:invitedTimestamp'),
    accessorKey: 'invitedTimestamp',
    filter: {
      shouldRange: true,
      hasNoMaxDate: true,
      filterType: FILTER_TYPES.DATE,
    },
    isDefaultCell: true,
  },
  {
    size: 200,
    header: i18next.t('tables:createdBy'),
    accessorKey: 'createdBy',
    filter: {
      filterType: FILTER_TYPES.SELECT_WITH_DYNAMIC_HINT,
    },
    isDefaultCell: true,
  },
  {
    size: 200,
    header: i18next.t('tables:status'),
    accessorKey: 'status',
    filter: {
      filterType: FILTER_TYPES.SELECT,
      options: ASSESSMENT_STATUSES_OPTIONS,
    },
    cell: {
      withBubble: true,
    },
  },
  {
    size: 200,
    header: i18next.t('tables:providerAssignment'),
    accessorKey: 'providerAssignment',
    filter: {},
    cell: {},
    isDefaultCell: true,
  },
  {
    size: 200,
    header: i18next.t('tables:uploadFailureReason'),
    accessorKey: 'uploadFailureReason',
    filter: {},
    cell: {},
    isDefaultCell: true,
  },
  {
    size: 200,
    header: i18next.t('tables:documentUploadTimestamp'),
    accessorKey: 'documentUploadTimestamp',
    filter: {
      shouldRange: true,
      filterType: FILTER_TYPES.DATE,
    },
    cell: {},
    isDefaultCell: true,
  },
  {
    size: 200,
    header: i18next.t('tables:botUploadStatus'),
    accessorKey: 'botUploadStatus',
    filter: {
      filterType: FILTER_TYPES.SELECT,
      options: BOT_UPLOADS_STATUSES_OPTIONS,
    },
    cell: {},
  },
];
